import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useCart } from "../context/CartContext";
import { createOrder } from "../firebase/orderService";
import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase/config";

export default function OrderSuccess() {
  const { clearCart } = useCart();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("confirming"); // confirming | done | error

  useEffect(() => {
    const sessionId = params.get("session_id");
    if (!sessionId) {
      setStatus("error");
      return;
    }

    const verify = httpsCallable(functions, "verifyAndSaveOrder");
    verify({ sessionId })
      .then(() => {
        clearCart();
        setStatus("done");
      })
      .catch(() => setStatus("error"));
  }, []);

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#080604",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "24px",
      }}
    >
      <p
        style={{
          color: "#c9a96e",
          fontFamily: "Cormorant Garamond, serif",
          fontSize: "clamp(2rem, 4vw, 3rem)",
          fontWeight: 300,
        }}
      >
        {status === "confirming" && "Confirming your order..."}
        {status === "done" && "Thank you for your order."}
        {status === "error" && "Something went wrong."}
      </p>
      {status === "done" && (
        <button
          onClick={() => navigate("/shop")}
          style={{
            background: "none",
            border: "1px solid rgba(201,169,110,0.3)",
            color: "#c9a96e",
            padding: "10px 28px",
            fontSize: "0.65rem",
            letterSpacing: "0.2em",
            textTransform: "uppercase",
            cursor: "pointer",
            fontFamily: "Jost, sans-serif",
          }}
        >
          Continue Shopping
        </button>
      )}
    </div>
  );
}
